export * from './ApplicationUpdateForm.component';
